import { ADD_TOAST, REMOVE_ALL_TOAST } from "./types";

export const addToast = toast => {
  // example payload
  // {
  //   msg: "Profile saved succesfully",
  //   appearance: "success", "error"
  //   autoDismiss: bool, - default false
  //   autoDismissTimeout: 5000, - default 2000ms
  // }
  return { type: ADD_TOAST, payload: toast };
};

// export const removeToast = toastId => {
//   return { type: REMOVE_TOAST, payload: toastId };
// };

export const removeAllToasts = () => {
  return { type: REMOVE_ALL_TOAST };
};
